export const ScheduledEmailTypeKeys = {
  immediate: 'immediate',
  scheduled: 'scheduled',
  recurrent: 'recurrent',
}
